import { Button, Container, Grid, Paper, Box, Typography } from '@mui/material';
import {
  PersonSearch,
  MonetizationOn,
  Speed,
  BarChart,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function DealerLanding() {
  const navigate = useNavigate();

  return (
    <>
      <Box>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            sx={{ mb: 1 }}
            textAlign="center"
            fontWeight={500}
          >
            Connect with Ready-to-Buy Customers
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 4 }} textAlign="center">
            We automatically connect you with qualified buyers in your area.
            <br />
            Sign up to access analytics, insights, and advanced tools - but
            you&apos;ll still receive and close leads either way.
          </Typography>

          <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/dealer/signup')}
              sx={{ px: 4, py: 1.5 }}
            >
              Access Advanced Features
            </Button>
          </Container>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 8 } }}>
        <Typography variant="h4" textAlign="center" sx={{ mb: 6 }}>
          How It Works
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: '100%', textAlign: 'center' }}
            >
              <PersonSearch
                sx={{ fontSize: 40, color: 'primary.main', mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                1. Access Quality Leads
              </Typography>
              <Typography>
                Receive real-time notifications when customers are actively
                searching for vehicles in your inventory.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: '100%', textAlign: 'center' }}
            >
              <Speed sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                2. Submit Quick Offers
              </Typography>
              <Typography>
                Easily submit competitive offers through our streamlined
                platform. Adjust in real-time based on market dynamics.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: '100%', textAlign: 'center' }}
            >
              <MonetizationOn
                sx={{ fontSize: 40, color: 'primary.main', mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                3. Win More Sales
              </Typography>
              <Typography>
                Connect directly with interested buyers when they accept your
                offer. No tire kickers - just serious customers.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper
              elevation={2}
              sx={{ p: 3, height: '100%', textAlign: 'center' }}
            >
              <BarChart sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                4. Track Performance
              </Typography>
              <Typography>
                Access detailed analytics on your offers, win rates, and
                customer engagement to optimize your strategy.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg" sx={{ pb: 8 }}>
        <Typography variant="h4" textAlign="center" sx={{ mb: 4 }}>
          Why Choose DealerScout
        </Typography>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom color="primary">
              Hassle-Free Lead Generation
            </Typography>
            <Typography paragraph>
              DealerScout automatically connects qualified buyers with relevant
              dealerships in their area. You&apos;ll receive leads and can close
              deals whether you&apos;re signed up or not.
            </Typography>
            <Typography paragraph>
              Sign up for a free account to unlock powerful tools: detailed
              analytics, performance tracking, and market insights to optimize
              your strategy.
            </Typography>
            <Typography>
              With our success-based pricing, you only pay when you complete a
              sale - ensuring risk-free lead generation for your dealership.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 2 }}>
              <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper' }}>
                <Typography variant="h6" gutterBottom color="primary">
                  Free Account Benefits
                </Typography>
                <Typography paragraph>
                  ✓ Detailed analytics and reporting
                </Typography>
                <Typography paragraph>
                  ✓ Real-time competitive insights
                </Typography>
                <Typography paragraph>
                  ✓ Performance tracking dashboard
                </Typography>
                <Typography paragraph>
                  ✓ Streamlined lead management system
                </Typography>
                <Typography paragraph>
                  ✓ Market insights to optimize your strategy
                </Typography>
                <Typography>✓ Risk-free lead generation</Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
